<template lang="pug">
div
  Input(
    v-model="textInput"
    type="textarea"
    placeholder="2000\n2200-2800"
    :rows="6"
  )
</template>

<script>
export default {
    name: "Http2UpgradeListByGroup",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            textInput: "",
        };
    },
    watch: {
        // 將父層的 value 顯示在 textarea 中
        value: {
            immediate: true,
            handler(newVal) {
                this.textInput = newVal.join("\n");
            },
        },
        // 當 textarea 被修改時，轉換為純字串陣列並 emit
        textInput(val) {
            const parsed = val
                .split("\n")
                .map((p) => p.trim())
                .filter((p) => p); // 移除空行
            this.$emit("input", parsed);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/Http2UpgradeListByGroup.vue